// extracted by mini-css-extract-plugin
export var blockBtn = "main-module--block-btn--e91e6";
export var btnBlock = "main-module--btn-block--13ed7";
export var mainTitle = "main-module--main-title--d3fc0";
export var sec = "main-module--sec--157d7";